<template>
  <div class="main">
    <div class="top" style="position:fixed; top : 0; z-index:999">
      <img src="../assets/img_logo_zhunya.png" width="146px" height="60px" style="margin-left:10%;" />
      <popper
        style="margin-right:10%"
        trigger="hover"
        :options="{
      placement: 'top',
      modifiers: { offset: { offset: '0,10px' } }
    }"
      >
        <img src="../assets/img_qrcode.png" alt width="160px" height="170px" />

        <div
          slot="reference"
          style="width: 140px;height: 40px;background: #FFE038;border-radius: 24px; display:flex; align-items:center;justify-content: center;"
        >
          <span style="fontSize:16px; color:#282525">点我扫码下载</span>
        </div>
      </popper>
    </div>
    <div style="height:180px"></div>

    <div class="centerBody">
      <div class="body">
        <div id="certify">
          <div class="swiper-container">
            <div class="swiper-wrapper">
              <div class="swiper-slide">
                <img src="../components/swiper/images/certify01.png" />
                <!-- <p>非常难得又值钱的认证证书</p> -->
              </div>
              <div class="swiper-slide">
                <img src="../components/swiper/images/certify02.png" />
                <!-- <p>深圳市优秀互联网企业认定证书</p> -->
              </div>
              <div class="swiper-slide">
                <img src="../components/swiper/images/certify03.png" />
                <!-- <p>质量管理体系认证荣誉证书</p> -->
              </div>
              <div class="swiper-slide">
                <img src="../components/swiper/images/certify04.png" />
                <!-- <p>计算机软件著作权登记证书</p> -->
              </div>
              <!-- <div class="swiper-slide"><img src="images/certify05.png" />
                    <p>增值电信业务经营许可证</p>
              </div>-->
            </div>
          </div>
          <div class="swiper-pagination"></div>
        </div>
        <img
          src="../assets/img_tianxiang.png"
          alt
          width="200px"
          height="354px"
          class="imgTianxiang"
        />
      </div>
      <div>
        <div class="centerTopText">{{title1}}</div>
        <div style="margin-left:122px; margin-top:60px">
          <img @click="goIos" src="../assets/btn_iphone.png" alt width="190px" height="64px" />
          <img
            src="../assets/btn_android.png"
            alt
            width="190px"
            height="64px"
            style="margin-left:20px"
          />
        </div>
      </div>
    </div>
    <div
      style="margin-top:135px; color:white; fontSize:12px; display: flex; align-items: center;justify-content: center; opacity:0.5;"
    >
      <span  @click="goMiitWeb" style="cursor: pointer;">天迅信息 Copyright © 2023 皖ICP备14007050号-7</span>
      <img
        v-if="true"
        style="width:12px; height:12px;margin-left:4px;margin-right:4px"
        src=".././assets/beian.png"
      />
      <span v-if="true" @click="goGAWeb" style="cursor: pointer;">皖公网安备 34011102002364号</span>
    </div>
    <div style="height:20px;width:20px"></div>
  </div>
</template>

<script>
import Swiper from "swiper";
import "swiper/dist/css/swiper.css";
import "../components/swiper/css/certify.css";
import Popper from "vue-popperjs";
import "vue-popperjs/dist/vue-popper.css";
export default {
  name: "HelloWorld",
  data() {
    return {
      title1: "123",
    };
  },
  components: {
    popper: Popper,
  },
  methods: {
    goMiitWeb(){
       window.location.href = "https://beian.miit.gov.cn";
    },
    goGAWeb() {
      window.location.href =
        "http://www.beian.gov.cn/portal/registerSystemInfo?recordcode=34011102002364";
    },
    goIos() {
      window.location.href = "https://apps.apple.com/cn/app/id1242740961";
    },
  },
  watch: {
    title1(newV, oldV) {
      console.log("111111");
    },
  },
  mounted() {
    let that = this;
    that.title1 = "牌阵全方位解析";
    new Swiper("#certify .swiper-container", {
      watchSlidesProgress: true,
      slidesPerView: "auto",
      centeredSlides: true,
      loop: true,
      loopedSlides: 5,
      autoplay: {
        disableOnInteraction: false,
      },
      slideToClickedSlide: true,
      // disableOnInteraction: false,
      navigation: {
        // nextEl: '.swiper-button-next',
        // prevEl: '.swiper-button-prev',
      },
      pagination: {
        el: ".swiper-pagination",
        clickable: true,
      },
      on: {
        slideChangeTransitionEnd: function () {
          //   alert(this.activeIndex); //切换结束时，告诉我现在是第几个slide
          //   that.title1 = "213";

          switch (this.activeIndex) {
            case 4:
              that.title1 = "牌阵全方位解析";
              break;
            case 5:
              that.title1 = "78张牌多维度剖析";
              break;
            case 6:
              that.title1 = "情感财富事业解读";
              break;
            case 7:
              that.title1 = "数百问题总有答案";
              break;
            case 8:
              that.title1 = "牌阵全方位解析";
              break;

            default:
              break;
          }
          //   console.log(that.title1);
        },
        progress: function (progress) {
          for (var i = 0; i < this.slides.length; i++) {
            var slide = this.slides.eq(i);
            var slideProgress = this.slides[i].progress;
            var modify = 1;
            if (Math.abs(slideProgress) > 1) {
              modify = (Math.abs(slideProgress) - 1) * 0.3 + 1;
            }
            var translate = slideProgress * modify * 100 + "px";
            var scale = 1 - Math.abs(slideProgress) / 10;
            var zIndex = 999 - Math.abs(Math.round(10 * slideProgress));
            slide.transform(
              "translateX(" + translate + ") scale(" + scale + ")"
            );
            slide.css("zIndex", zIndex);
            slide.css("opacity", 1);
            if (Math.abs(slideProgress) > 3) {
              slide.css("opacity", 0);
            }
          }
        },
        setTransition: function (transition) {
          for (var i = 0; i < this.slides.length; i++) {
            var slide = this.slides.eq(i);
            slide.transition(transition);
          }
        },
      },
    });
    // that.title1 = "1245";
    // setInterval(() => {
    //   that.title1 = "12";
    //   //   this.$set(this.title1, "12");
    //   //   console.log((this.title1 = "1245"));
    //   //   this.$nextTick(function () {});
    // }, 1000);
    // new Swiper(".swiper-container", {
    //   autoplay: {
    //     //自动播放
    //     delay: 2500,
    //     disableOnInteraction: false,
    //   },
    // });
  },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.main {
  width: 100vw;
  background-color: #6068d5;
  margin: 0 auto;
}

.top {
  display: flex;
  justify-content: space-between;
  align-items: center;

  width: 100vw;
  height: 80px;
  background-color: #6068d5;
}

.body {
  position: relative;
}
.centerBody {
  display: flex;
  justify-content: center;
  align-items: center;
  background-color: #6068d5;
}

.centerTopText {
  font-size: 48px;
  font-family: PingFangSC-Semibold, PingFang SC;
  font-weight: 600;
  color: #ffffff;
  line-height: 67px;
  margin-left: 122px;
  text-align: left;
}

.imgTianxiang {
  position: absolute;
  bottom: 20px;
  left: 0px;
  z-index: 10;
}

.swiper-container {
  --swiper-theme-color: #ff6600;
  --swiper-pagination-color: #00ff33; /* 两种都可以 */
}
</style>



// WEBPACK FOOTER //
// src/components/MainPage.vue